const envFromScript = (typeof window !== 'undefined') ? document.getElementById('env')?.innerText : "{}";
const env = JSON.parse(envFromScript);

export default env;
